import { createGlobalStyle } from "styled-components";
import smoothscroll from "smoothscroll-polyfill";

smoothscroll.polyfill();

const GlobalStyles = createGlobalStyle`
   * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
        font-family: "Inter", sans-serif;

   }
      html,body {
         overscroll-behavior: none;
      }

   body {
      width: 100%;
      height: 100%;
      overflow-x: hidden;
      background-color: #000;
      font-family: serif;
      scroll-behavior: smooth;
   }

   ::-webkit-scrollbar {
      width: 6px;
   }

   ::-webkit-scrollbar-track {
      background: #0f0f0f; 
   }
   
   ::-webkit-scrollbar-thumb {
      background:rgb(52, 52, 52);
      border-radius: 50px;
   }

   ::-webkit-scrollbar-thumb:hover {
      background:rgb(52, 52, 52);
   }

   .wrap {
   max-width:1150px;
   padding:20px;
   width:100%;
   margin-left:auto;
   margin-right:auto;
   }
   .block-space {
   height:100px;
   width:100%;
   }
`;

export default GlobalStyles;
